﻿(function ($) {
    $(document).ready(function () {
        vaneck.membership.initializeSpinner();
    });
})(jQuery);